import ReactDOM from "react-dom";

const DropdownTDFetch = ({ isOpen, buttonRef, children }) => {
  if (!isOpen || !buttonRef) return null;

  const rect = buttonRef.getBoundingClientRect();
  const viewportWidth = window.innerWidth;

  const dropdownWidth = Math.min(rect.width, viewportWidth - 32);

  return ReactDOM.createPortal(
    <div
      className="absolute z-[9999]"
      style={{
        top: rect.bottom + window.scrollY + 6,
        left: Math.max(16, rect.left + window.scrollX),
        width: dropdownWidth,
      }}
    >
      {children}
    </div>,
    document.body,
  );
};
export default DropdownTDFetch;
